import { Component, Input, OnInit } from '@angular/core';
import { PermissionActions, User } from '../../models';
import { UserService } from 'src/app/core/user.service';
import { Router } from '@angular/router';
import { BlendService } from '../../services/blend.service';
import { ChargebeeService } from '../../services/chargebee.service';

@Component({
  selector: 'app-upgrade-plan-button',
  templateUrl: './upgrade-plan-button.component.html',
  styleUrls: ['./upgrade-plan-button.component.scss']
})
export class UpgradePlanButtonComponent implements OnInit {
  @Input() public buttonColor: 'default' = 'default';
  @Input() label: string = 'Manage subscription';
  @Input() leadIcon?: string;

  public user: User;
  public canManageBilling: boolean;

  constructor(
    public userService: UserService,
    private router: Router,
    private blendService: BlendService,
    private chargebeeService: ChargebeeService,
  ) { }
  ngOnInit(): void {

    this.user = this.userService.getUser();
    this.canManageBilling = this.userService.checkPermission(PermissionActions.MANAGE_BILLING);
  }
  onUpgradePlan() {
      this.blendService.addEventsForUpgradeButton();
      this.chargebeeService.openPortal();
  };
}
